import { AxiosResponse } from "axios";
import apiClient from "../../../../shared/infrastructure/api/client";
import { CreateGroupPatientDTO, GroupPatient } from "../../domain/GroupPatient";

/** Groups of the signed-in therapist. The server never takes an owner from us. */
export const GroupPatientAPI = {
    list: (): Promise<AxiosResponse<GroupPatient[]>> => apiClient.get("/group-patients"),

    get: (id: string): Promise<AxiosResponse<GroupPatient>> =>
        apiClient.get(`/group-patients/${id}`),

    create: (data: CreateGroupPatientDTO): Promise<AxiosResponse<GroupPatient>> =>
        apiClient.post("/group-patients", data),

    rename: (id: string, displayName: string | null): Promise<AxiosResponse<GroupPatient>> =>
        apiClient.patch(`/group-patients/${id}`, { display_name: displayName }),

    addMember: (id: string, patientId: string): Promise<AxiosResponse<GroupPatient>> =>
        apiClient.put(`/group-patients/${id}/members/${patientId}`),

    removeMember: (id: string, patientId: string): Promise<AxiosResponse<GroupPatient>> =>
        apiClient.delete(`/group-patients/${id}/members/${patientId}`),

    delete: (id: string): Promise<AxiosResponse<void>> => apiClient.delete(`/group-patients/${id}`),
};
